/** Estaciones humanas — capa experiencial (espejo del servidor, solo UI). */

export const HUMAN_SEASONS = {
    renovacion: {
        key: 'renovacion',
        label: 'Renovación',
        emoji: '🌱',
        tone: 'cultivar lo nuevo con calma',
        accent: '#6b9b6e',
        softBg: 'rgba(107, 155, 110, 0.12)',
    },
    expansion: {
        key: 'expansion',
        label: 'Expansión',
        emoji: '☀️',
        tone: 'sostener energía con intención',
        accent: '#d4a017',
        softBg: 'rgba(212, 160, 23, 0.12)',
    },
    transicion: {
        key: 'transicion',
        label: 'Transición',
        emoji: '🍂',
        tone: 'honrar lo que está cambiando',
        accent: '#c47c4a',
        softBg: 'rgba(196, 124, 74, 0.12)',
    },
    regeneracion: {
        key: 'regeneracion',
        label: 'Regeneración',
        emoji: '❄️',
        tone: 'cuidar ritmo y descanso',
        accent: '#5b8fa8',
        softBg: 'rgba(91, 143, 168, 0.12)',
    },
};

export function getSeasonCycle(date = new Date()) {
    const d = date instanceof Date ? date : new Date(date);
    const year = d.getFullYear();
    const quarter = Math.floor(d.getMonth() / 3) + 1;
    return `${year}-Q${quarter}`;
}

export function getCurrentHumanSeason(date = new Date()) {
    const d = date instanceof Date ? date : new Date(date);
    const month = d.getMonth();
    let key = 'transicion';
    if (month === 11 || month <= 1) key = 'regeneracion';
    else if (month <= 4) key = 'renovacion';
    else if (month <= 7) key = 'expansion';
    return HUMAN_SEASONS[key];
}

export function getCycleReviewIntro(season = getCurrentHumanSeason()) {
    return {
        title: 'Revisión de ciclo',
        lead: 'Las personas cambian.',
        body: 'Queremos saber si algo importante cambió en ti en este nuevo ciclo. No es una calificación: es un minuto para revisar cómo estás.',
        seasonLabel: `${season.emoji} ${season.label}`,
        seasonTone: season.tone,
        durationHint: '1 minuto · 10 preguntas',
    };
}

export const SEASON_MONTH_RANGES = {
    regeneracion: 'Diciembre – Febrero',
    renovacion: 'Marzo – Mayo',
    expansion: 'Junio – Agosto',
    transicion: 'Septiembre – Noviembre',
};

export function listHumanSeasonsForMasters() {
    return Object.values(HUMAN_SEASONS).map((s) => ({
        ...s,
        monthRange: SEASON_MONTH_RANGES[s.key] || '',
    }));
}
